<div class="filter-set-wrapper" [class.mat-fields-theme]="useMatFields">
	<div *ngFor="let group of groups; let groupIndex = index" class="filter-group-wrapper" [hidden]="group.hidden" [class.read-only]="group.readOnly">
		<span *ngIf="groupIndex > 0" class="and-label">{{ 'AND' | translate }}</span>
			
		<div class="filter-group">

			<div *ngFor="let filter of group?.filters; let index = index" class="filter-wrapper">
				<span *ngIf="index > 0" class="or-label">{{ 'OR' | translate }}</span>
				<span *ngIf="index === 0" class="or-spacer"></span>

				<bb-vertical-filter [useMatFields]="useMatFields" [filter]="filter" [allowDatasource]="filterConfig?.allowDatasource" (onFilterChanged)="filterChange()"></bb-vertical-filter>
				<a class="remove" (click)="deleteFilter(groupIndex, index)"><i class="fa-solid fa-times"></i></a>
			</div>

			<span class="or-spacer"></span>
			<a (click)="addFilter(groupIndex)" class="add-filter button"><i class="fa fa-plus"></i>{{ 'ADD_FILTER' | translate }}</a>

		</div>
	
	</div>
	<span class="button add-group" (click)="addGroup()" ><i class="fa fa-plus"></i>{{'ADD_FILTER_SET' | translate}}</span>
</div>
